import { memo } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { PropertySets } from '@/admin-pages/PropertySets/PropertySets';
import { PropertySet } from '@/admin-pages/PropertySets/Item/PropertySet';

export const OrganizationPropertySetsList = memo(() => {
    const { orgId } = useParams<{ orgId: string }>();
    return <PropertySets orgId={Number(orgId)} />
})

export const OrganizationPropertySetDetail = memo(() => {
    const { orgId } = useParams<{ orgId: string }>();
    return <PropertySet orgId={Number(orgId)} />
})

export default memo(function PhysicalPropertySets() {
  return (
    <Outlet />
  );
});
